const getDefaultsFromPostinstall = () => undefined;
export { getDefaultsFromPostinstall };